import { render, staticRenderFns } from "./chooseDevelopModal1.vue?vue&type=template&id=dbdda794&scoped=true"
import script from "./chooseDevelopModal1.vue?vue&type=script&lang=js"
export * from "./chooseDevelopModal1.vue?vue&type=script&lang=js"
import style0 from "./chooseDevelopModal1.vue?vue&type=style&index=0&id=dbdda794&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdda794",
  null
  
)

export default component.exports